export type GearItem = {
  id: string;
  name: string;
  daily_rate: number;
  weekly_rate?: number;
};

export type GearKit = {
  id: string;
  name: string;
  item_ids: string[];
  override_price?: number;
  weekly_override_price?: number;
};

export type CartageConfig = {
  method: 'flat' | 'mileage' | 'none';
  flat_rate?: number;
  mileage_rate?: number;
};

export type GearConfig = {
  gearItems: GearItem[];
  gearKits: GearKit[];
  cartage: CartageConfig;
  weekLengthDays: number;
};

export const DEFAULT_GEAR_CONFIG: GearConfig = {
  gearItems: [],
  gearKits: [],
  cartage: { method: 'none' },
  weekLengthDays: 5,
};
